import { Controller } from "stimulus"

export default class extends Controller {
  initialize() {
    this.info = JSON.parse(this.data.get("data"))
    this.current_user = this.info.user
    this.post = this.info.post
    this.gamification_action_logs_path = this.info.gamification_action_logs_path
  }

  connect() {
    let article_scroll = false;

    let FeatureArticleTag = tag => tag.slug.match(/^([a-z]|\d)*-article-\d*$/)

    function reachedEndOfArticle() {
      let desktopMinWidth = 992
      let mobileNavbarHeight = 72

      let checkpointDiv = document.getElementsByClassName('article__author')[0]
      let distanceToTop = checkpointDiv ? checkpointDiv.getBoundingClientRect().top : 0
      let padding = window.innerWidth < desktopMinWidth ? mobileNavbarHeight : 0

      return distanceToTop < (window.innerHeight - padding)
    }

    this.check_page_scroll = () => {
      if (!article_scroll && reachedEndOfArticle()) {
        if (this.current_user && this.post && this.post.tags && this.post.tags.some((t) => t.slug === "article_of_the_day")) {
          $.ajax({
            method: 'POST',
            url: this.gamification_action_logs_path,
            data: {
              action_log: {
                action: 'Read article of the day'
              }
            }
          })
        }
        if (this.current_user && this.post && this.post.tags.some(FeatureArticleTag)) {
          $.ajax({
            method: 'POST',
            url: this.gamification_action_logs_path,
            data: {
              action_log: {
                action: 'Read a featured article',
                properties: {
                  tag: `${this.post.tags.map((tags) => tags.slug).join(', ')}`
                }
              }
            }
          })
        }
        article_scroll = true;
      }
    }

    $(window).scroll(this.check_page_scroll)

    var monitor = setInterval(() => {
      var elem = document.activeElement;
      if (elem && elem.id == 'media-video') {
        clearInterval(monitor);
        if (this.current_user && this.post) {
          $.ajax({
            method: 'POST',
            url: this.gamification_action_logs_path,
            data: {
              action_log: {
                action: 'Watched a video',
                properties: {
                  category: `${this.post.categories.map((cat) => cat.slug).join(', ')}`
                }
              }
            }
          })
        }
      }
    }, 100);
  }

  disconnect() {
    $(window).off("scroll", this.check_page_scroll)
  }
}
